import styled from "styled-components/macro";

export const StyledDiagnosticTestListPage = styled.div`
  width: 100%;
`;
